import React, { useState } from "react";
import { motion } from "framer-motion"
import Motion from "../logic/interfaces/Motion";

interface EffectProps{
    motion: Motion
    removeAnim: Function
}

    /**
     * Despite name returns animation!
     * @param props motion - animation, position - position to render
     * @returns JSX.Element with animation
     */
export default function  Effect(props: EffectProps): JSX.Element {
    const [mot] = useState(props.motion)

    return(<>
        <motion.img
            variants={mot.anim}
            animate={"animate"}
            initial={"initial"}
            transition={mot.anim.transition}
            onAnimationStart={()=>{ console.warn(`animation with Id ${mot.id} has started`)}}
            onAnimationComplete={() => { 
                console.warn(`animation with Id ${mot.id} finished`); 
                props.removeAnim(mot.id)
            }}
        
            src={mot.image}
            style={{
                position: 'absolute',
                pointerEvents: 'none',
                margin: 0,
                width: mot.width,
                height: mot.height,
            }}
            alt={mot.image}
        />
    </>)
}